module.exports = __webpack_public_path__ + "img/setting-pariwisata.f6ccd81d.png";